import popupActionTypes from './popup.types';

export const clearPopupText = () => ({
    type: popupActionTypes.CLEAR_POPUP_TEXT,
});
